<template>
  <b-form-group
    :label="$t('fields.startDate')"
    label-for="start_date"
  >
    <b-input-group>
      <b-form-datepicker
        id="start_date"
        v-model="dataItem.start_date"
        v-bind="datepickerProps"
        :placeholder="$t('fields.selectDate')"
        :min="minDate"
      />
      <template #append>
        <b-button
          variant="warning"
          @click="dataItem.start_date = null"
        >
          <feather-icon icon="XIcon" />
        </b-button>
      </template>
    </b-input-group>
    <b-alert
      v-if="isEditMode && isPastDate"
      show
      variant="warning"
      class="mt-1 mb-0"
    >
      <div class="alert-body">
        {{ $t('tasks.form.pastDateWarning') }}
      </div>
    </b-alert>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormDatepicker, BAlert, BInputGroup, BButton,
} from 'bootstrap-vue'
import { datepickerLocale } from '@/libs/i18n/datepicker'

export default {
  name: 'TasksStartDateCard',
  components: {
    BFormGroup, BFormDatepicker, BAlert, BInputGroup, BButton,
  },
  mixins: [datepickerLocale],
  computed: {
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isEditMode() {
      return !!this.dataItem.id
    },
    isPastDate() {
      if (!this.dataItem.start_date) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const start = new Date(this.dataItem.start_date)
      start.setHours(0, 0, 0, 0)
      return start < today
    },
    minDate() {
      if (this.isEditMode) return null
      return new Date().toISOString().split('T')[0]
    },
  },
}
</script>
